'use client';

import { ContextualPopup } from '@/ui';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import type { FC } from 'react';
import { useDataPopup } from '../hooks/useDataPopup';
import { useTruth } from '../hooks/useTruth';

export const Location: FC = () => {
  const { DataPopup } = useDataPopup();
  const [localStorage] = useLocalStorage('privacyArticle', {});
  const { dataBlocks } = useTruth();

  const { lastKnownLatLong = [0, 0] } = localStorage;

  const isUnknownLocation =
    +lastKnownLatLong[0] === 0 && +lastKnownLatLong[1] === 0;

  return (
    <DataPopup
      handle={dataBlocks?.city?.value || 'Prague'}
      subheading={
        <>
          A main way of getting your location is through looking your IP up in a
          geolocation database. There are also ways to guess it more accuratelly
          using your current timezone information.
          <br />
          <br />
          Though, using IP for geolocation can be unreliable if you're using a
          VPN.
        </>
      }
      dataVisualisation={
        !isUnknownLocation ? (
          <ContextualPopup.WorldMap
            lat={lastKnownLatLong[0]}
            long={lastKnownLatLong[1]}
          />
        ) : undefined
      }
      confidence={
        !isUnknownLocation
          ? {
              rangeLow: 50,
              rangeHigh: 80,
            }
          : undefined
      }
      dataBlocks={{
        ip: dataBlocks.ip,
        city: dataBlocks.city,
        country: dataBlocks.country,
        timezone: dataBlocks.timezone,
      }}
    />
  );
};
